import { styled } from 'styled-components';

export const Wrapper = styled.button<{ $color: ButtonProps['color']; $ghost: boolean }>`
    all: unset;
    padding: ${({ $ghost }) => ($ghost ? '0.25em' : '0.5em 0.75em')};
    align-self: flex-start;
    border-radius: var(--border-radius);
    background: ${({ $color, $ghost }) => {
        if ($ghost) {
            return 'transparent';
        } else if ($color === 'accent') {
            return 'var(--color-accent)';
        } else if ($color === 'error') {
            return 'var(--color-error)';
        }
        return 'var(--color-primary)';
    }};
    color: ${({ $color, $ghost }) => {
        if ($ghost) {
            if ($color === 'primary') {
                return 'var(--color-primary)';
            } else if ($color === 'accent') {
                return 'var(--color-accent)';
            } else if ($color === 'error') {
                return 'var(--color-error)';
            }
        }
        return 'var(--color-white)';
    }};
    font-size: 1rem;

    &:hover {
        cursor: pointer;
        transform: scale(0.95);
        transition: transform 0.4s ease-out;
    }

    &:disabled,
    &:disabled * {
        cursor: not-allowed;
        color: var(--color-disabled);
    }
`;
